<template>
	<div class="pageBox">
		<Header current='download' ref="Header"></Header>
		<div class="pageBox_cen">
			<!--
			<div class="download-banner">
				<div class="banner-title">{{ $t('download.title') }}</div>
			</div>
			-->
			<div class="download-content">
				<div class="download-inner">
					<indexTitle :title="$t('download.title')" :more="false" mabot="20px"></indexTitle>
					<p class="download-subtitle">{{ $t('download.subtitle') }}</p>
					<div class="filter-bar">
						<div class="category-tabs">
							<div class="tab" :class="{ active: activeTab === 'all' }" @click="switchTab('all')">{{ $t('download.tab_all') }}</div>
							<div v-for="cat in categories" :key="cat.id" class="tab"
								:class="{ active: activeTab === cat.id }" @click="switchTab(cat.id)">{{ cat.name }}</div>
						</div>
						<div class="search-wrapper">
							<input v-model="searchKeyword" class="search-input"
								:placeholder="$t('download.searchPlaceholder')" @input="onSearchInput" />
						</div>
					</div>
					<div v-loading="loading">
						<template v-if="paginatedItems.length">
							<downloads :list="withDownloadUrl(paginatedItems)"></downloads>
							<div class="pagination-wrapper">
								<myPagination @current-change="pageChange" :allNum="total" :limit="pageSize"></myPagination>
							</div>
						</template>
						<el-empty v-else :description="$t('暂无数据')"></el-empty>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from "@/components/header.vue"
import Footer from "@/components/footer.vue"
import indexTitle from "@/components/c/indexTitle.vue"
import downloads from "@/views/product/components/downloads1.vue"
import myPagination from "@/components/myPagination.vue"
import configa from "@/utils/config.js"
import { get_download_list } from "@/api/download.js"

export default {
    components: {
        Header,
        Footer,
        indexTitle,
        downloads,
        myPagination,
    },
    data() {
        return {
            loading: false,
            categories: [],
            allItems: [],
            activeTab: 'all',
            searchKeyword: '',
            currentPage: 1,
            pageSize: 6,
            navHidden: false,
            lastScrollTop: 0,
        }
    },
    computed: {
        filteredItems() {
            let items = this.allItems
            // 按分类筛选
            if (this.activeTab !== 'all') {
                items = items.filter(item => item.category_id === this.activeTab)
            }
            // 按标题/描述搜索
            if (this.searchKeyword.trim()) {
                const kw = this.searchKeyword.trim().toLowerCase()
                items = items.filter(item =>
                    (item.title && item.title.toLowerCase().includes(kw)) ||
                    (item.desc && item.desc.toLowerCase().includes(kw))
                )
            }
            return items
        },
        paginatedItems() {
            const start = (this.currentPage - 1) * this.pageSize
            return this.filteredItems.slice(start, start + this.pageSize)
        },
        total() {
            return this.filteredItems.length
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.initHeader();
        this.getList();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        switchTab(tab) {
            this.activeTab = tab
            this.currentPage = 1
        },
        onSearchInput() {
            this.currentPage = 1
        },
        pageChange(page) {
            this.currentPage = page
        },
        // 给每个下载项附加内部转发地址 url，复用 downloads.vue 的 downloadFile(item.url)
        withDownloadUrl(list) {
            return (list || []).map(item => ({
                ...item,
                url: item.uuid
                    ? configa.baseUrl + '/aohua.download/download?uuid=' + item.uuid
                    : configa.baseUrl + '/aohua.download/download?id=' + item.id
            }))
        },
        getList() {
            this.loading = true;
            get_download_list().then(res => {
                const cats = (res.data && res.data.categories) || []
                this.categories = cats
                // 扁平化所有项，用于统一筛选/搜索/分页
                const all = []
                cats.forEach(cat => {
                    (cat.list || []).forEach(item => {
                        all.push({ ...item, category_id: cat.id })
                    })
                })
                this.allItems = all
            }).catch(() => {}).finally(() => {
                this.loading = false;
            })
        },
        initHeader() {
            var element;
            if (this.nowVibe == 'pc') {
                element = document.documentElement
            } else {
                element = document.documentElement.scrollTop ? document.documentElement : document.body;
            }
            let scrollTop = element.scrollTop;
            try {
                if (scrollTop == 0) {
                    this.$refs.Header.headerHover = false;
                    this.$refs.Header.headerTrue = false;
                } else {
                    this.$refs.Header.headerTrue = true;
                    this.$refs.Header.headerHover = true;
                }
            } catch (e) {}
        },
        handleScroll() {
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            if (currentScrollTop > this.lastScrollTop) {
                this.navHidden = true;
            } else {
                this.navHidden = false;
            }
            this.lastScrollTop = currentScrollTop;
            try {
    
                if (currentScrollTop == 0) {
                    if (!this.$refs.Header.navHead) {
                        this.$refs.Header.headerHover = false;
                    }
                    this.$refs.Header.headerTrue = false;
                } else {
                    this.$refs.Header.headerTrue = true;
                    this.$refs.Header.headerHover = true;
                }
            } catch (e) {}
        },
    },
}
</script>

<style scoped lang="scss">
.pageBox {
	display: flex;
	flex-direction: column;
	min-height: 100vh;

	.pageBox_cen {
		flex: 1;
	}
}

.download-banner {
	width: 100%;
	height: 420px;
	background: linear-gradient(135deg, #1a1a1a 0%, #3d3d3d 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;

	.banner-title {
		font-size: 48px;
		font-weight: bold;
		color: #FFFFFF;
		letter-spacing: 4px;
		text-align: center;
	}
}

.download-content {
	width: 100%;
	background: #FFFFFF;
	padding: 80px 20px 100px;
	box-sizing: border-box;
}

.download-inner {
	max-width: 1200px;
	width: 100%;
	margin: 0 auto;
}

.download-subtitle {
	font-size: 15px;
	color: #666666;
	line-height: 1.6;
	margin: 0 0 48px;
}

.filter-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	gap: 16px;
	margin-bottom: 40px;
	border-bottom: 1px solid #E5E5E5;

	.category-tabs {
		display: flex;
		flex-wrap: wrap;
		gap: 0;

		.tab {
			padding: 18px 32px;
			font-size: 16px;
			font-weight: 400;
			color: #999999;
			cursor: pointer;
			user-select: none;
			border-bottom: 2px solid transparent;
			margin-bottom: -1px;
			transition: all 0.2s;

			&:hover {
				color: #000000;
			}

			&.active {
				color: #000000;
				border-bottom-color: #000000;
				font-weight: 500;
			}
		}
	}
}

.search-wrapper {
	.search-input {
		height: 40px;
		padding: 0 16px;
		border: 1px solid #E5E5E5;
		border-radius: 2px;
		font-size: 14px;
		color: #333333;
		outline: none;
		width: 240px;
		transition: border-color 0.2s;
		box-sizing: border-box;

		&:focus {
			border-color: #000000;
		}

		&::placeholder {
			color: #999999;
		}
	}
}

.pagination-wrapper {
	display: flex;
	justify-content: center;
	margin-top: 48px;
}

@media screen and (max-width: 1200px) {
	.download-banner {
		height: 320px;

		.banner-title {
			font-size: 32px;
			letter-spacing: 2px;
		}
	}

	.download-content {
		padding: 76px 20px 70px;
	}

	.category-tabs .tab {
		padding: 14px 20px;
		font-size: 14px;
	}

	.search-wrapper .search-input {
		width: 200px;
	}
}

@media screen and (max-width: 768px) {
	.download-banner {
		height: 260px;

		.banner-title {
			font-size: 26px;
		}
	}

	.download-content {
		padding: 76px 16px 60px;
	}

	.download-subtitle {
		margin-bottom: 30px;
	}

	.filter-bar {
		margin-bottom: 24px;
		border-bottom: none;

		.category-tabs .tab {
			padding: 12px 14px;
			font-size: 13px;
		}

		.search-wrapper {
			width: 100%;
		}

		.search-wrapper .search-input {
			width: 100%;
		}
	}
}
</style>
